export default __webpack_public_path__ + "static/logo-283d197a4e960914f18dd6d9b8713795.png";